import React from 'react';

const ArrowBack = ({ className }) => {
  return (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="21.5" cy="21.5" r="21.5" fill="#232323" fillOpacity="0.96" />
      <path d="M16 21.878H28M16 21.878L21.0769 17M16 21.878L21.0769 27" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

export default ArrowBack;